import React from 'react';
import ReactDOM from 'react-dom';
import 'typeface-montserrat';
import './i18n';
import './index.less';
import './App.less';
import InterestTargeting from "./Containers/ProductDetailsPageAdmin/components/InterestTargeting";

ReactDOM.render(
  <InterestTargeting /> ,
  document.getElementById('interests-root')
);
